export type RecommendationFeatureId = 'content-catchup' | 'summarize';

/**
 * Maps recommendation feature id (service response) to nudge id (consumer)
 */
export const RecommendationFeatureMap: Record<RecommendationFeatureId, string> = {
	'content-catchup': 'summarize-changes-ai-action',
	summarize: 'summarize-page-ai-action',
};
